import { useLanguage } from '../contexts/LanguageContext';

const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      feed: 'Feed',
      groups: 'Groups', 
      events: 'Events',
      myNetwork: 'My Network',
      resources: 'Resources',
      tenders: 'Tenders',
      userGuide: 'User Guide',
      profile: 'Profile',
      logout: 'Logout'
    },
    
    // Common
    common: {
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      search: 'Search',
      filter: 'Filter',
      share: 'Share',
      like: 'Like',
      comment: 'Comment',
      post: 'Post',
      create: 'Create',
      join: 'Join',
      leave: 'Leave',
      submit: 'Submit',
      reset: 'Reset',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      close: 'Close',
      open: 'Open',
      view: 'View',
      download: 'Download',
      upload: 'Upload',
      connect: 'Connect',
      follow: 'Follow',
      unfollow: 'Unfollow',
      following: 'Following',
      followers: 'Followers',
      members: 'Members',
      posts: 'Posts',
      comments: 'Comments',
      likes: 'Likes',
      views: 'Views',
      date: 'Date',
      time: 'Time',
      location: 'Location',
      description: 'Description',
      title: 'Title',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      website: 'Website',
      company: 'Company',
      industry: 'Industry',
      required: 'Required',
      optional: 'Optional',
      yes: 'Yes',
      no: 'No',
      all: 'All',
      active: 'Active',
      inactive: 'Inactive',
      public: 'Public',
      private: 'Private',
      draft: 'Draft',
      published: 'Published',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      completed: 'Completed',
      cancelled: 'Cancelled',
      success: 'Success',
      error: 'Error',
      warning: 'Warning',
      info: 'Info'
    },

    // Auth
    auth: {
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      welcomeBack: 'Welcome back',
      signInToAccount: 'Sign in to your account',
      createAccount: 'Create your account',
      joinCommunity: 'Join the Labamu Hub',
      email: 'Email address',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      fullName: 'Full Name',
      username: 'Username',
      companyName: 'Company Name',
      industryTags: 'Industry Tags',
      location: 'Location',
      phoneNumber: 'Phone Number',
      alreadyHaveAccount: 'Already have an account?',
      dontHaveAccount: "Don't have an account?",
      signIn: 'Sign in',
      signUp: 'Sign up',
      forgotPassword: 'Forgot your password?',
      rememberMe: 'Remember me',
      loginFailed: 'Login failed. Please try again.',
      registrationFailed: 'Registration failed. Please try again.',
      invalidCredentials: 'Invalid email or password',
      emailRequired: 'Email is required',
      passwordRequired: 'Password is required',
      nameRequired: 'Full name is required',
      usernameRequired: 'Username is required'
    },

    // Feed
    feed: {
      socialFeed: 'Social Feed',
      shareThoughts: 'Share your thoughts with the community',
      whatsOnYourMind: "What's on your mind?",
      createPost: 'Create Post',
      sharePost: 'Share Post',
      writePost: 'Write a post...',
      noPostsYet: 'No posts yet',
      beFirstToShare: 'Be the first to share something with the community!',
      showingPosts: 'Showing {count} posts',
      writeComment: 'Write a comment...',
      noComments: 'No comments yet',
      beFirstToComment: 'Be the first to comment!',
      copyLink: 'Copy Link',
      copyLinkDescription: 'Copy link to clipboard',
      shareToSocial: 'Share to Social Media',
      postedInGroup: 'Posted in group',
      timeAgo: '{time} ago',
      justNow: 'Just now',
      minutesAgo: '{minutes}m ago',
      hoursAgo: '{hours}h ago',
      daysAgo: '{days}d ago',
      weeksAgo: '{weeks}w ago',
      monthsAgo: '{months}mo ago',
      yearsAgo: '{years}y ago'
    },

    // Groups  
    groups: {
      businessGroups: 'Business Groups',
      myGroups: 'My Groups',
      allGroups: 'All Groups',
      createGroup: 'Create Group',
      joinGroup: 'Join Group',
      leaveGroup: 'Leave Group',
      groupName: 'Group Name',
      groupDescription: 'Group Description',
      groupType: 'Group Type',
      industryTags: 'Industry Tags',
      groupRules: 'Group Rules',
      searchGroups: 'Search groups...',
      noGroupsFound: 'No groups found',
      createFirstGroup: 'Create the first group for your industry!',
      memberCount: '{count} members',
      postCount: '{count} posts',
      admin: 'Admin',
      moderator: 'Moderator',
      member: 'Member'
    },

    // Events
    events: {
      upcomingEvents: 'Upcoming Events',
      myEvents: 'My Events',
      allEvents: 'All Events',
      createEvent: 'Create Event',
      eventName: 'Event Name',
      eventDescription: 'Event Description',
      eventType: 'Event Type',
      startDate: 'Start Date',
      endDate: 'End Date',
      venue: 'Venue',
      maxAttendees: 'Max Attendees',
      price: 'Price',
      tags: 'Tags',
      register: 'Register',
      registered: 'Registered',
      noEventsFound: 'No events found',
      createFirstEvent: 'Create the first event!',
      attendees: '{count} attendees',
      freeEvent: 'Free',
      onlineEvent: 'Online',
      offlineEvent: 'Offline',
      workshop: 'Workshop',
      seminar: 'Seminar',
      conference: 'Conference',
      networking: 'Networking',
      webinar: 'Webinar'
    },

    // My Network
    network: {
      myNetwork: 'My Network',
      myConnections: 'My Connections',
      suggestions: 'Suggestions',
      findPeople: 'Find People',
      invitations: 'Invitations',
      pending: 'Pending',
      networkInsights: 'Network Insights',
      invitePeople: 'Invite People',
      searchUsers: 'Search for users to connect with...',
      noUsersFound: 'No users found',
      searchPeople: 'Search for people to connect with',
      searchDifferentKeywords: 'Try searching with different keywords',
      noConnectionsYet: 'No connections yet',
      buildNetwork: 'Start building your network by connecting with merchants in your industry',
      noSuggestions: 'No suggestions available',
      suggestionsWillAppear: "We'll suggest new connections based on your network and interests",
      invitationsSent: 'No invitations sent',
      invitePeopleDescription: 'Invite people to join the Labamu Hub',
      totalConnections: 'Total Connections',
      newSuggestions: 'New Suggestions',
      networkGrowth: 'Network Growth',
      networkActivity: 'Network Activity',
      mutualConnections: '{count} mutual connections',
      suggestedBased: 'Suggested based on mutual interests',
      emailAddress: 'Email Address',
      personalMessage: 'Personal Message',
      addPersonalMessage: 'Add a personal message to your invitation',
      invitationSent: 'Invitation sent successfully!',
      sendInvitation: 'Send Invitation'
    },

    // Resources
    resources: {
      businessResources: 'Business Resources',
      allResources: 'All Resources',
      guides: 'Guides',
      tools: 'Tools',
      templates: 'Templates',
      articles: 'Articles',
      videos: 'Videos',
      webinars: 'Webinars',
      searchResources: 'Search resources...',
      noResourcesFound: 'No resources found',
      browseResources: 'Browse our collection of business resources',
      resourceType: 'Resource Type',
      category: 'Category',
      duration: 'Duration',
      readTime: 'Read Time',
      author: 'Author',
      organization: 'Organization',
      viewCount: '{count} views'
    },

    // Tenders
    tenders: {
      businessTenders: 'Business Tenders',
      myTenders: 'My Tenders',
      allTenders: 'All Tenders',
      createTender: 'Create Tender',
      tenderTitle: 'Tender Title',
      tenderDescription: 'Tender Description',
      category: 'Category',
      budgetRange: 'Budget Range',
      deadline: 'Deadline',
      requirements: 'Requirements',
      contactPerson: 'Contact Person',
      submitProposal: 'Submit Proposal',
      proposalAmount: 'Proposal Amount',
      proposalDescription: 'Proposal Description',
      searchTenders: 'Search tenders...',
      noTendersFound: 'No tenders found',
      postFirstTender: 'Post the first tender opportunity!',
      proposalCount: '{count} proposals',
      daysLeft: '{days} days left',
      expired: 'Expired',
      budgetMin: 'Minimum Budget',
      budgetMax: 'Maximum Budget',
      requirement: 'Requirement',
      addRequirement: 'Add Requirement'
    },

    // Profile
    profile: {
      myProfile: 'My Profile',
      editProfile: 'Edit Profile',
      businessProfile: 'Business Profile',
      personalInfo: 'Personal Information',
      businessInfo: 'Business Information',
      businessName: 'Business Name',
      businessDescription: 'Business Description',
      foundedYear: 'Founded Year',
      employeeCount: 'Employee Count',
      businessEmail: 'Business Email',
      businessPhone: 'Business Phone',
      address: 'Address',
      specialties: 'Specialties',
      certifications: 'Certifications',
      socialLinks: 'Social Links',
      noGroupsJoined: 'No groups joined yet',
      joinGroupsDescription: 'Join groups to connect with like-minded business professionals',
      activityStats: 'Activity Stats',
      groupsJoined: 'Groups Joined',
      postsCreated: 'Posts Created',
      eventsAttended: 'Events Attended',
      connectionsEasy: 'connections',
      addSpecialty: 'Add Specialty'
    },

    // Home
    home: {
      welcome: 'Welcome to Labamu Hub',
      tagline: 'Connect, collaborate, and grow your business with Indonesia\'s premier merchant community platform.',
      getStarted: 'Get Started',
      learnMore: 'Learn More',
      connectNetwork: 'Connect & Network',
      connectDescription: 'Build relationships with fellow merchants, suppliers, and industry experts across Indonesia.',
      discoverOpportunities: 'Discover Opportunities',
      discoverDescription: 'Find group buying deals, tender opportunities, and exclusive trade offers from your network.',
      growTogether: 'Grow Together',
      growDescription: 'Share insights, learn from peers, and grow your business through collaborative commerce.',
      tradeEfficiently: 'Trade Efficiently',
      tradeDescription: 'Post tenders, organize group buys, and streamline your procurement process.',
      joinToday: 'Join thousands of merchants already growing their business through community collaboration.',
      signUpNow: 'Sign Up Now',
      alreadyMember: 'Already a member?',
      loginHere: 'Login here'
    },

    // Messages
    messages: {
      postLinkCopied: 'Post link copied to clipboard!',
      invitationSentSuccess: 'Invitation sent successfully!',
      errorOccurred: 'An error occurred. Please try again.',
      invalidFileType: 'Invalid file type. Please select a valid file.'
    }
  },

  id: {
    // Navigation
    nav: {
      home: 'Beranda',
      feed: 'Umpan',
      groups: 'Grup', 
      events: 'Acara',
      myNetwork: 'Jaringan Saya',
      resources: 'Sumber Daya',
      tenders: 'Tender',
      userGuide: 'Panduan Pengguna',
      profile: 'Profil',
      logout: 'Keluar'
    },
    
    // Common
    common: {
      loading: 'Memuat...',
      save: 'Simpan',
      cancel: 'Batal',
      edit: 'Edit',
      delete: 'Hapus',
      search: 'Cari',
      filter: 'Filter',
      share: 'Bagikan',
      like: 'Suka',
      comment: 'Komentar',
      post: 'Posting',
      create: 'Buat',
      join: 'Gabung',
      leave: 'Keluar',
      submit: 'Kirim',
      reset: 'Reset',
      back: 'Kembali',
      next: 'Selanjutnya',
      previous: 'Sebelumnya',
      close: 'Tutup',
      open: 'Buka',
      view: 'Lihat',
      download: 'Unduh',
      upload: 'Unggah',
      connect: 'Terhubung',
      follow: 'Ikuti',
      unfollow: 'Berhenti Mengikuti',
      following: 'Mengikuti',
      followers: 'Pengikut',
      members: 'Anggota',
      posts: 'Postingan',
      comments: 'Komentar',
      likes: 'Suka',
      views: 'Dilihat',
      date: 'Tanggal',
      time: 'Waktu',
      location: 'Lokasi',
      description: 'Deskripsi',
      title: 'Judul',
      name: 'Nama',
      email: 'Email',
      phone: 'Telepon',
      website: 'Website',
      company: 'Perusahaan',
      industry: 'Industri',
      required: 'Wajib',
      optional: 'Opsional',
      yes: 'Ya',
      no: 'Tidak',
      all: 'Semua',
      active: 'Aktif',
      inactive: 'Tidak Aktif',
      public: 'Publik',
      private: 'Pribadi',
      draft: 'Draf',
      published: 'Diterbitkan',
      pending: 'Menunggu',
      approved: 'Disetujui',
      rejected: 'Ditolak',
      completed: 'Selesai',
      cancelled: 'Dibatalkan',
      success: 'Berhasil',
      error: 'Error',
      warning: 'Peringatan',
      info: 'Info'
    },

    // Auth
    auth: {
      login: 'Masuk',
      register: 'Daftar',
      logout: 'Keluar',
      welcomeBack: 'Selamat datang kembali',
      signInToAccount: 'Masuk ke akun Anda',
      createAccount: 'Buat akun Anda',
      joinCommunity: 'Bergabung dengan Komunitas Labamu',
      email: 'Alamat email',
      password: 'Kata sandi',
      confirmPassword: 'Konfirmasi Kata Sandi',
      fullName: 'Nama Lengkap',
      username: 'Nama Pengguna',
      companyName: 'Nama Perusahaan',
      industryTags: 'Tag Industri',
      location: 'Lokasi',
      phoneNumber: 'Nomor Telepon',
      alreadyHaveAccount: 'Sudah punya akun?',
      dontHaveAccount: 'Belum punya akun?',
      signIn: 'Masuk',
      signUp: 'Daftar',
      forgotPassword: 'Lupa kata sandi?',
      rememberMe: 'Ingat saya',
      loginFailed: 'Login gagal. Silakan coba lagi.',
      registrationFailed: 'Pendaftaran gagal. Silakan coba lagi.',
      invalidCredentials: 'Email atau kata sandi tidak valid',
      emailRequired: 'Email wajib diisi',
      passwordRequired: 'Kata sandi wajib diisi',
      nameRequired: 'Nama lengkap wajib diisi',
      usernameRequired: 'Nama pengguna wajib diisi'
    },

    // Feed
    feed: {
      socialFeed: 'Umpan Sosial',
      shareThoughts: 'Bagikan pemikiran Anda dengan komunitas',
      whatsOnYourMind: 'Apa yang Anda pikirkan?',
      createPost: 'Buat Postingan',
      sharePost: 'Bagikan Postingan',
      writePost: 'Tulis postingan...',
      noPostsYet: 'Belum ada postingan',
      beFirstToShare: 'Jadilah yang pertama berbagi sesuatu dengan komunitas!',
      showingPosts: 'Menampilkan {count} postingan',
      writeComment: 'Tulis komentar...',
      noComments: 'Belum ada komentar',
      beFirstToComment: 'Jadilah yang pertama berkomentar!',
      copyLink: 'Salin Tautan',
      copyLinkDescription: 'Salin tautan ke papan klip',
      shareToSocial: 'Bagikan ke Media Sosial',
      postedInGroup: 'Diposting di grup',
      timeAgo: '{time} yang lalu',
      justNow: 'Baru saja',
      minutesAgo: '{minutes}m yang lalu',
      hoursAgo: '{hours}j yang lalu',
      daysAgo: '{days}h yang lalu',
      weeksAgo: '{weeks}mg yang lalu',
      monthsAgo: '{months}bl yang lalu',
      yearsAgo: '{years}th yang lalu'
    },

    // Groups
    groups: {
      businessGroups: 'Grup Bisnis',
      myGroups: 'Grup Saya',
      allGroups: 'Semua Grup',
      createGroup: 'Buat Grup',
      joinGroup: 'Gabung Grup',
      leaveGroup: 'Keluar Grup',
      groupName: 'Nama Grup',
      groupDescription: 'Deskripsi Grup',
      groupType: 'Jenis Grup',
      industryTags: 'Tag Industri',
      groupRules: 'Aturan Grup',
      searchGroups: 'Cari grup...',
      noGroupsFound: 'Tidak ada grup ditemukan',
      createFirstGroup: 'Buat grup pertama untuk industri Anda!',
      memberCount: '{count} anggota',
      postCount: '{count} postingan',
      admin: 'Admin',
      moderator: 'Moderator',
      member: 'Anggota'
    },

    // Events
    events: {
      upcomingEvents: 'Acara Mendatang',
      myEvents: 'Acara Saya',
      allEvents: 'Semua Acara',
      createEvent: 'Buat Acara',
      eventName: 'Nama Acara',
      eventDescription: 'Deskripsi Acara',
      eventType: 'Jenis Acara',
      startDate: 'Tanggal Mulai',
      endDate: 'Tanggal Selesai',
      venue: 'Tempat',
      maxAttendees: 'Maksimal Peserta',
      price: 'Harga',
      tags: 'Tag',
      register: 'Daftar',
      registered: 'Terdaftar',
      noEventsFound: 'Tidak ada acara ditemukan',
      createFirstEvent: 'Buat acara pertama!',
      attendees: '{count} peserta',
      freeEvent: 'Gratis',
      onlineEvent: 'Online',
      offlineEvent: 'Offline',
      workshop: 'Workshop',
      seminar: 'Seminar',
      conference: 'Konferensi',
      networking: 'Networking',
      webinar: 'Webinar'
    },

    // My Network
    network: {
      myNetwork: 'Jaringan Saya',
      myConnections: 'Koneksi Saya',
      suggestions: 'Saran',
      findPeople: 'Cari Orang',
      invitations: 'Undangan',
      pending: 'Menunggu',
      networkInsights: 'Wawasan Jaringan',
      invitePeople: 'Undang Orang',
      searchUsers: 'Cari pengguna untuk terhubung...',
      noUsersFound: 'Tidak ada pengguna ditemukan',
      searchPeople: 'Cari orang untuk terhubung',
      searchDifferentKeywords: 'Coba cari dengan kata kunci yang berbeda',
      noConnectionsYet: 'Belum ada koneksi',
      buildNetwork: 'Mulai membangun jaringan Anda dengan terhubung dengan pedagang di industri Anda',
      noSuggestions: 'Tidak ada saran tersedia',
      suggestionsWillAppear: 'Kami akan menyarankan koneksi baru berdasarkan jaringan dan minat Anda',
      invitationsSent: 'Tidak ada undangan terkirim',
      invitePeopleDescription: 'Undang orang untuk bergabung dengan Komunitas Labamu',
      totalConnections: 'Total Koneksi',
      newSuggestions: 'Saran Baru',
      networkGrowth: 'Pertumbuhan Jaringan',
      networkActivity: 'Aktivitas Jaringan',
      mutualConnections: '{count} koneksi mutual',
      suggestedBased: 'Disarankan berdasarkan minat bersama',
      emailAddress: 'Alamat Email',
      personalMessage: 'Pesan Pribadi',
      addPersonalMessage: 'Tambahkan pesan pribadi ke undangan Anda',
      invitationSent: 'Undangan berhasil dikirim!',
      sendInvitation: 'Kirim Undangan'
    },

    // Resources
    resources: {
      businessResources: 'Sumber Daya Bisnis',
      allResources: 'Semua Sumber Daya',
      guides: 'Panduan',
      tools: 'Alat',
      templates: 'Template',
      articles: 'Artikel',
      videos: 'Video',
      webinars: 'Webinar',
      searchResources: 'Cari sumber daya...',
      noResourcesFound: 'Tidak ada sumber daya ditemukan',
      browseResources: 'Jelajahi koleksi sumber daya bisnis kami',
      resourceType: 'Jenis Sumber Daya',
      category: 'Kategori',
      duration: 'Durasi',
      readTime: 'Waktu Baca',
      author: 'Penulis',
      organization: 'Organisasi',
      viewCount: '{count} dilihat'
    },

    // Tenders
    tenders: {
      businessTenders: 'Tender Bisnis',
      myTenders: 'Tender Saya',
      allTenders: 'Semua Tender',
      createTender: 'Buat Tender',
      tenderTitle: 'Judul Tender',
      tenderDescription: 'Deskripsi Tender',
      category: 'Kategori',
      budgetRange: 'Rentang Anggaran',
      deadline: 'Tenggat Waktu',
      requirements: 'Persyaratan',
      contactPerson: 'Kontak Person',
      submitProposal: 'Kirim Proposal',
      proposalAmount: 'Jumlah Proposal',
      proposalDescription: 'Deskripsi Proposal',
      searchTenders: 'Cari tender...',
      noTendersFound: 'Tidak ada tender ditemukan',
      postFirstTender: 'Posting kesempatan tender pertama!',
      proposalCount: '{count} proposal',
      daysLeft: '{days} hari tersisa',
      expired: 'Kedaluwarsa',
      budgetMin: 'Anggaran Minimum',
      budgetMax: 'Anggaran Maksimum',
      requirement: 'Persyaratan',
      addRequirement: 'Tambah Persyaratan'
    },

    // Profile
    profile: {
      myProfile: 'Profil Saya',
      editProfile: 'Edit Profil',
      businessProfile: 'Profil Bisnis',
      personalInfo: 'Informasi Pribadi',
      businessInfo: 'Informasi Bisnis',
      businessName: 'Nama Bisnis',
      businessDescription: 'Deskripsi Bisnis',
      foundedYear: 'Tahun Didirikan',
      employeeCount: 'Jumlah Karyawan',
      businessEmail: 'Email Bisnis',
      businessPhone: 'Telepon Bisnis',
      address: 'Alamat',
      specialties: 'Spesialisasi',
      certifications: 'Sertifikasi',
      socialLinks: 'Tautan Sosial',
      noGroupsJoined: 'Belum bergabung dengan grup',
      joinGroupsDescription: 'Bergabunglah dengan grup untuk terhubung dengan profesional bisnis yang berpikiran sama',
      activityStats: 'Statistik Aktivitas',
      groupsJoined: 'Grup yang Diikuti',
      postsCreated: 'Postingan Dibuat',
      eventsAttended: 'Acara yang Dihadiri',
      connectionsEasy: 'koneksi',
      addSpecialty: 'Tambah Spesialisasi'
    },

    // Home
    home: {
      welcome: 'Selamat datang di Komunitas Labamu',
      tagline: 'Terhubung, berkolaborasi, dan kembangkan bisnis Anda dengan platform komunitas pedagang terkemuka di Indonesia.',
      getStarted: 'Mulai',
      learnMore: 'Pelajari Lebih Lanjut',
      connectNetwork: 'Terhubung & Networking',
      connectDescription: 'Bangun hubungan dengan sesama pedagang, pemasok, dan ahli industri di seluruh Indonesia.',
      discoverOpportunities: 'Temukan Peluang',
      discoverDescription: 'Temukan penawaran pembelian grup, kesempatan tender, dan penawaran perdagangan eksklusif dari jaringan Anda.',
      growTogether: 'Berkembang Bersama',
      growDescription: 'Bagikan wawasan, belajar dari rekan, dan kembangkan bisnis Anda melalui perdagangan kolaboratif.',
      tradeEfficiently: 'Berdagang Efisien',
      tradeDescription: 'Posting tender, atur pembelian grup, dan sederhanakan proses pengadaan Anda.',
      joinToday: 'Bergabunglah dengan ribuan pedagang yang sudah mengembangkan bisnis mereka melalui kolaborasi komunitas.',
      signUpNow: 'Daftar Sekarang',
      alreadyMember: 'Sudah menjadi anggota?',
      loginHere: 'Masuk di sini'
    },

    // Messages
    messages: {
      postLinkCopied: 'Tautan postingan disalin ke papan klip!',
      invitationSentSuccess: 'Undangan berhasil dikirim!',
      errorOccurred: 'Terjadi kesalahan. Silakan coba lagi.',
      invalidFileType: 'Jenis file tidak valid. Silakan pilih file yang valid.'
    }
  }
};

export const useTranslation = () => {
  const { currentLanguage } = useLanguage();
  
  const t = (key, params = {}) => {
    const keys = key.split('.');
    let value = translations[currentLanguage];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        // Fallback to English if translation not found
        value = translations['en'];
        for (const fallbackKey of keys) {
          if (value && typeof value === 'object') {
            value = value[fallbackKey];
          } else {
            return key; // Return key if no translation found
          }
        }
        break;
      }
    }
    
    if (typeof value === 'string') {
      // Replace parameters in the string
      return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
        return params[paramKey] !== undefined ? params[paramKey] : match;
      });
    }
    
    return key; // Return key if value is not a string
  };

  return { t };
};

export default translations;